"use client";
/**
 * @typedef {import("@prismicio/client").Content.ServiceTabsContentSlice} ServiceTabsContentSlice
 * @typedef {import("@prismicio/react").SliceComponentProps<ServiceTabsContentSlice>} ServiceTabsContentProps
 * @type {import("react").FC<ServiceTabsContentProps>}
 */
import * as prismic from "@prismicio/client";
import { useState } from "react";
import Link from "next/link";
import { PrismicRichText } from "@/components/PrismicRichText";
import { PrismicNextImage } from "@prismicio/next";
import { H3Icon } from "@heroicons/react/20/solid";

const ServiceTabsContent = ({ slice }) => {
  const [isTab, setIsTab] = useState(1);
  const handleTab = (i) => {
    setIsTab(i);
  };

  const resolveCtaUrl = (linkField) => {
    if (!linkField) return null;

    if (linkField.link_type === "Document") {
      if (linkField.type === "service" && linkField.uid) {
        return `/earwax-removal/${linkField.uid}`;
      }

      return prismic.asLink(linkField) ?? linkField.url ?? null;
    }

    return linkField.url ?? prismic.asLink(linkField) ?? null;
  };

  return (
    <section
      data-slice-type={slice.slice_type}
      data-slice-variation={slice.variation}
    >
      <section className="section-service page-home-2 tf-spacing-1">
        <div className="tf-container">
          <div className="row">
            <div className="col-12">
              <div className="heading-section ">
                <p
                  className="text-2 sub wow fadeInUp"
                  data-wow-duration={1000}
                  data-wow-delay="0s"
                >
                  {slice.primary.eyebrow}
                </p>
                <h2
                  className="wow fadeInUp"
                  data-wow-duration={1000}
                  data-wow-delay="0s"
                >
                  {prismic.asText(slice.primary.main_title)}
                </h2>

                <PrismicRichText field={slice.primary.intro_text} />
              </div>
              {slice.primary.tabs && (
                <div className="widget-tabs ">
                  <ul className="widget-menu-tab overflow-x-auto">
                    {slice.primary.tabs.map((item, key) => (
                      <li
                        key={key}
                        className={`item-title ${isTab === key + 1 ? "active" : ""}`}
                        onClick={() => handleTab(key + 1)}
                      >
                        {item.tab_label}
                      </li>
                    ))}
                  </ul>
                  <div className="widget-content-tab">
                    {slice.primary.tabs.map((item, key) => {
                      const linkUrl = resolveCtaUrl(item?.cta_link);
                      const linkText = item?.cta_link?.text;
                      const hasLink = Boolean(linkUrl);
                      return (
                        <div
                          key={key}
                          className="widget-content-inner"
                          style={{
                            display: `${isTab == key + 1 ? "block" : "none"}`,
                          }}
                        >
                          <div className="box-service">
                            <div
                              className="image-wrap wow fadeInLeft effec-overlay w-1/2"
                              data-wow-duration={1000}
                              data-wow-delay="0s"
                            >
                              <PrismicNextImage
                                field={item.media}
                                className="w-full"
                              />
                            </div>
                            <div className="content">
                              <div className="heading-section text-start ">
                                <p
                                  className="text-2 sub wow fadeInUp"
                                  data-wow-duration={1000}
                                  data-wow-delay="0s"
                                >
                                  {prismic.asText(item.service_label)}
                                </p>
                                <h3
                                  className="wow fadeInUp text-5xl leading-tight"
                                  data-wow-duration={1000}
                                  data-wow-delay="0s"
                                >
                                  {hasLink ? (
                                    <Link href={linkUrl}>
                                      {prismic.asText(item.service_title)}
                                    </Link>
                                  ) : (
                                    prismic.asText(item.service_title)
                                  )}
                                </h3>
                                <PrismicRichText
                                  field={item.service_description}
                                />
                              </div>
                              {hasLink && linkText ? (
                                <Link
                                  href={linkUrl}
                                  className="tf-btn-link z-5 wow fadeInUp"
                                  data-wow-duration={1000}
                                  data-wow-delay="0s"
                                >
                                  <span data-text="Read More">{linkText}</span>
                                  <i className="icon-ArrowRight" />
                                </Link>
                              ) : null}
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </section>
    </section>
  );
};

export default ServiceTabsContent;
